import { create} from 'zustand';
import { persist } from 'zustand/middleware';

const STORE_KEY = 'cancer-detect';

export interface IUserCancerDetectClicked {
  isCancerDetectClicked: boolean;
  setIsCancerDetectClicked: (value: boolean) => void;
}

export const useCancerDetectUser = create<IUserCancerDetectClicked>()(
  persist(
    (set) => ({
      isCancerDetectClicked: false,
      setIsCancerDetectClicked: (value) => set({ isCancerDetectClicked: value }),
    }),
    { name: STORE_KEY }
  ),
);

/**
 * Read the persisted CD-clicked flag straight from storage. Colocated with the
 * store so the persist key + serialized shape stay in one place. Independent of
 * whether `useCancerDetectUser` has rehydrated yet — so callers (e.g. the
 * context store's rehydrate) don't depend on store init order and stay correct
 * even if this store later moves to async storage.
 */
export const getPersistedCancerDetectClicked = (): boolean => {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return false;
    return Boolean(JSON.parse(raw)?.state?.isCancerDetectClicked);
  } catch {
    return false;
  }
};
